import { axios } from '../utils/axios';

class HttpRequestError extends Error {
  constructor(message, status) {
    super(message);
    this.status = status;
  }
}

const getHeaders = ({ headers, method, isFile }) =>
  isFile || method === 'DELETE'
    ? headers
    : { 'Content-Type': 'application/json', ...headers };

export default (url, { method, data, headers, isFile } = {}) => {
  const currentHeaders = getHeaders({ headers, method, isFile });

  const axiosPayload = {
    method,
    url,
    data: isFile ? data : JSON.stringify(data),
    headers: currentHeaders,
  };

  return axios(axiosPayload)
    .then((response) => (response.status === 204 ? {} : response.data))
    .catch((error) => {
      if (error.response) {
        const errorData = error.response.data;

        if (errorData.reason || errorData.error || errorData.errors) {
          const errorMessage =
            errorData.reason || errorData.message || errorData.errors;

          throw new HttpRequestError(errorMessage, error.response.status);
        }

        throw new HttpRequestError(
          JSON.stringify(errorData),
          error.response.status
        );
      }

      // eslint-disable-next-line no-console
      console.error(error);
      throw error;
    });
};
